import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=1ecb4467&scoped=true&"
import script from "./Doc.vue?vue&type=script&lang=js&"
export * from "./Doc.vue?vue&type=script&lang=js&"
import style0 from "./Doc.vue?vue&type=style&index=0&id=1ecb4467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb4467",
  null
  
)

export default component.exports